import { Platform } from 'react-native';
import * as Location from 'expo-location';
import { openCustomURL } from './common.utils';
import { baseApiUrl } from '../config/env';
import { getLocationDetail } from '../services/api/search.service';

export async function currentLocation() {
  //returns current position as array: [latitude, longitude]
  //need to call in async function to await response
  let locat;
  try {
    locat = await Location.getCurrentPositionAsync({});
    const startLat = JSON.stringify(locat.coords.latitude);
    const startLng = JSON.stringify(locat.coords.longitude);
    return [startLat, startLng];
  } catch (err) {
    alert(err); // Need to style alert
  }
}
export const getAddress = async (address) => {
  try {
    const response = await fetch(`${baseApiUrl}/search/getGeoCode?address=` + address);
    const json = await response.json();
    return JSON.parse(json);
  } catch (error) {
    console.error(error);
  }
};

export const getCMSorGoogle = async (item) => {
  let locationDetails = '';
  if (item.category !== 'G') {
    //call CMS
    locationDetails = await getLocationDetail(
      item.label,
      item.category,
      item.componentType,
      item.regionid
    );
  } else {
    //call google
    const googleGeoToCity = await getAddress(item.label);
    locationDetails = await transformGoogleAddress(googleGeoToCity);
  }
  return locationDetails;
};
export const transformGoogleAddress = async (googleGeoObj) => {
  const customGooglePlace = {
    displaylabel: {},
    address: '',
    city: '',
    country: '',
    latitude: '',
    longitude: '',
  };
  googleGeoObj.results[0].address_components.forEach((value) => {
    if (value.types.indexOf('locality') > -1) {
      customGooglePlace.city = value.long_name;
    }
    if (value.types.indexOf('country') > -1) {
      customGooglePlace.country = value.long_name;
    }
    console.log(value.types.indexOf('country'));
  });
  customGooglePlace.displaylabel.title = '';
  customGooglePlace.displaylabel.subtitle = googleGeoObj.results[0].formatted_address;
  customGooglePlace.address = googleGeoObj.results[0].formatted_address;
  customGooglePlace.latitude = googleGeoObj.results[0].geometry.location.lat;
  customGooglePlace.longitude = googleGeoObj.results[0].geometry.location.lng;
  return customGooglePlace;
};
export const getLatLng = async (address) => {
  if (address == 'My Current Location') {
    const latlng = await currentLocation();
    return latlng;
  } else {
    const latlng = [];
    const object = await getAddress(address);
    latlng.push(object?.results[0]?.geometry?.location?.lat);
    latlng.push(object?.results[0]?.geometry?.location?.lng);
    return latlng;
  }
};

export async function getDirections(type, endLatLng, startLatLng = 'current') {
  // type = "maps"/"waze"
  let start;
  if (startLatLng == 'current') {
    try {
      start = await currentLocation();
    } catch (err) {
      alert(err);
    }
  } else {
    start = startLatLng;
  }
  if (type == 'maps') {
    const url = Platform.select({
      ios: `maps:0,0?q=DropOff@${endLatLng[0]},${endLatLng[1]}`,
      android: `https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=${start[0]},${start[1]}&destination=${endLatLng[0]},${endLatLng[1]}`,
      default: `https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=${start[0]},${start[1]}&destination=${endLatLng[0]},${endLatLng[1]}`,
    });
    openCustomURL(url);
  } else if (type == 'waze') {
    const url = Platform.select({
      ios: `https://waze.com/ul?ll=${endLatLng[0]},${endLatLng[1]}&navigate=yes`,
      android: `https://waze.com/ul?ll=${endLatLng[0]},${endLatLng[1]}&navigate=yes`,
      default: `https://www.waze.com/livemap/directions?navigate=yes&to=${endLatLng[0]},${endLatLng[1]}&from=${start[0]},${start[1]}`,
    });
    openCustomURL(url);
  }
}

export async function requestRide(type, endLatLng) {
  // type = "uber"/"lyft"
  let start;
  try {
    start = await currentLocation();
  } catch (err) {
    alert(err);
  }
  if (type == 'uber') {
    const url = Platform.select({
      ios: `https://m.uber.com/ul/?client_id=<CLIENT_ID>&action=setPickup&pickup[latitude]=${start[0]}&pickup[longitude]=${start[1]}&pickup[nickname]=Pickup&dropoff[latitude]=${endLatLng[0]}&dropoff[longitude]=${endLatLng[1]}&dropoff[nickname]=dropoff`,
      android: `https://m.uber.com/ul/?client_id=<CLIENT_ID>&action=setPickup&pickup[latitude]=${start[0]}&pickup[longitude]=${start[1]}&pickup[nickname]=Pickup&dropoff[latitude]=${endLatLng[0]}&dropoff[longitude]=${endLatLng[1]}&dropoff[nickname]=dropoff`,
      default: `https://m.uber.com/?action=setPickup&client_id=%3CCLIENT_ID%3E&pickup[latitude]=${start[0]}&pickup[longitude]=${start[1]}&pickup[nickname]=Pickup&dropoff[latitude]=${endLatLng[0]}&dropoff[longitude]=${endLatLng[1]}&dropoff[nickname]=Dropoff`,
    });
    openCustomURL(url);
  } else if (type == 'lyft') {
    const url = Platform.select({
      ios: `lyft://ridetype?id=lyft&pickup[latitude]=${start[0]}&pickup[longitude]=${start[1]}&destination[latitude]=${endLatLng[0]}&destination[longitude]=${endLatLng[1]}`,
      android: `lyft://ridetype?id=lyft&pickup[latitude]=${start[0]}&pickup[longitude]=${start[1]}&destination[latitude]=${endLatLng[0]}&destination[longitude]=${endLatLng[1]}`,
      default: `https://ride.lyft.com/ridetype?origin=${start[0]}%2C${start[1]}&destination=${endLatLng[0]}%2C${endLatLng[1]}`,
    });
    openCustomURL(url);
  }
}
